module.exports = __webpack_public_path__ + "static/media/prefill-gif-sky-blue.b3eb27b5.gif";